var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styles from '../SettingsModalContent.module.scss';
import { SecondaryButton } from '../../../../components/SecondaryButton/SecondaryButton';
import { useTypeSelector } from '../../../../hooks/useTypeHooks';
import { selectPreferences } from '../../../../Redux/selectors/selectors';
import { constants } from '../settingConstants';
import { useActions } from '../../../../hooks/useActions';
var generalTabs = [
    {
        title: 'Global presets',
        value: constants.PRESETS,
    },
    {
        title: 'Strategy',
        value: constants.STRATEGY,
    },
    {
        title: 'Range',
        value: constants.RANGE,
    },
    {
        title: 'EV',
        value: constants.EV,
    },
    {
        title: 'Equity',
        value: constants.EQUITY,
    },
    {
        title: 'EqR',
        value: constants.EQR,
    },
    {
        title: 'Positions',
        value: constants.POSITIONS,
    },
    {
        title: 'Text & cell',
        value: constants.TEXT,
    },
    {
        title: 'Cards & trainer',
        value: constants.CARDS,
    },
];
var hotkeysTabs = [{ title: 'Trainer', value: 'trainer' }];
var LocalTabs = function () {
    var modalSettings = useTypeSelector(selectPreferences).modalSettings;
    var setModalLocalTab = useActions().setModalLocalTab;
    var tabs = modalSettings.globalTabs === constants.GENERAL ? generalTabs : hotkeysTabs;
    return (_jsx("section", __assign({ className: styles.localTabsWrapper }, { children: tabs.map(function (tab) {
            var isActive = tab.value === modalSettings.localTabs;
            return (_jsx(SecondaryButton, { title: tab.title, handleClick: function () { return setModalLocalTab(tab.value); }, isActive: isActive, isBordered: false, fontSize: '17px', style: {
                    display: 'flex',
                    alignItems: 'center',
                    width: '153px',
                } }, tab.value));
        }) })));
};
export default LocalTabs;
